
import { styled } from 'stitches.config';
import { useIntl } from 'react-intl';
import Typography from '@/components/sushi/Typography';
import { toCurrency } from '@/utils/numberFormatter';
import { CompoundInterestsGraphData } from './CompoundInterestsGraph';
import { palette } from 'theme/palette';

export type CompoundInterestsTooltipProps = {
  data: CompoundInterestsGraphData;
  isSimpleInterestsGraph?: boolean;
}
const currentYear = new Date().getFullYear();

export const CompoundInterestsTooltip = ({
 data,
 isSimpleInterestsGraph
}: CompoundInterestsTooltipProps) => {
  const { formatMessage } = useIntl();
  const {interests, netValue, payments, year} = data;

  return (
    <TooltipContainer>
      <Header>
        <Typography variant="bodyXS" color="secondary">
          {currentYear + year - 1}
        </Typography>
        <Typography variant="bodyXS" color="secondary">
          {toCurrency(netValue)}
        </Typography>
      </Header>
      <TooltipInfos>
        <InfoLine>
          <Typography variant="bodyXS">
            {formatMessage({
              id:  isSimpleInterestsGraph ? 'simple_interests_simulator.chart.legend.interests' : 'compound_interests_simulator.chart.legend.interests',
            })}
          </Typography>
          <TooltipInterests variant="bodyXS">
            {toCurrency(interests)}
          </TooltipInterests>
        </InfoLine>
        <InfoLine>
          <Typography variant="bodyXS">
            {formatMessage({
              id: isSimpleInterestsGraph ? 'simple_interests_simulator.chart.legend.payments' : 'compound_interests_simulator.chart.legend.payments',
            })}
          </Typography>
          <TooltipPayments variant="bodyXS">
            {toCurrency(payments)}
          </TooltipPayments>
        </InfoLine>
      </TooltipInfos>
    </TooltipContainer>
  );
};

const TooltipContainer = styled('div', {
  minWidth: '200px',
  backdropFilter: 'blur(12px)',
  background: 'rgba(19, 19, 20, 0.2)',
  borderRadius: '$4',
  '&:active, &:focus': {
    border: '1px solid $borderSecondary',
  },
});

const Header = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px',
  borderBottom: '1px solid $webappTertiary',
});

const TooltipInfos = styled('div', {
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

const InfoLine = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

const TooltipInterests = styled(Typography, {
  color: `${palette.brand500} !important`,
});

const TooltipPayments = styled(Typography, {
  color: `${palette.sky400} !important`,
});
